import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { RetailerFooter } from "@faire/retailer-visitor-shared/components/Footer/RetailerFooter";
import { SDUIBannerRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Banner/SDUIBannerRenderer";
import { SDUICarouselRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Carousel/SDUICarouselRenderer";
import { SDUIGridRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Grid/SDUIGridRenderer";
import { SDUIHeaderRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Header/SDUIHeaderRenderer";
import { SDUICategoryPageLayoutElementRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/LayoutElement/SDUICategoryPageLayoutElementRenderer";
import { SDUISpacerRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Spacer/SDUISpacerRenderer";
import { BannerLoadingSkeleton } from "@faire/retailer-visitor-shared/components/SDUI/LoadingRenderers/Components/BannerLoadingSkeleton";
import { CarouselLoadingSkeleton } from "@faire/retailer-visitor-shared/components/SDUI/LoadingRenderers/Components/CarouselLoadingSkeleton";
import { SDUIColumnSectionRenderer } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/ColumnSection/SDUIColumnSectionRenderer";
import { SDUIFilterablePaginatedSectionRenderer } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/SDUIFilterablePaginatedSectionRenderer";
import { SDUICategoryPageContents } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/SDUICategoryPageContents";
import { Z_INDICES } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/LoggedInCategoryPageStyles";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { WhenVisibilityIsImminent } from "@faire/web--source/ui/VisibilitySensor/WhenVisibilityIsImminent";
import * as React from "react";
import styled from "styled-components";
var hubComponentRenderers = {
    layout_element: {
        active: SDUICategoryPageLayoutElementRenderer,
        pending: CarouselLoadingSkeleton
    },
    carousel_component: {
        active: SDUICarouselRenderer,
        pending: CarouselLoadingSkeleton
    },
    banner_component: {
        active: SDUIBannerRenderer,
        pending: BannerLoadingSkeleton
    },
    spacer_component: {
        active: SDUISpacerRenderer
    },
    header_component: {
        active: SDUIHeaderRenderer
    },
    grid_component: {
        active: SDUIGridRenderer
    }
};
var hubSectionRenders = {
    column_section: SDUIColumnSectionRenderer,
    filterable_paginated_section: SDUIFilterablePaginatedSectionRenderer
};
export var SDUICategoryPageBase = function() {
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(SDUICategoryPageContents, {
                componentRenderers: hubComponentRenderers,
                sectionRenderers: hubSectionRenders
            }),
            /*#__PURE__*/ _jsx(WhenVisibilityIsImminent, {
                customizePlaceholder: /*#__PURE__*/ _jsx(RetailerFooterPlaceholder, {}),
                children: /*#__PURE__*/ _jsx(StyledRetailerFooter, {
                    hideReferral: true
                })
            })
        ]
    });
};
var StyledRetailerFooter = styled(RetailerFooter).withConfig({
    componentId: "sc-b077c403-0"
})([
    "",
    "{background-color:white;position:relative;z-index:",
    ";}"
], responsiveMediaQueries.desktopAndAbove, Z_INDICES.footer.desktopAndAbove);
var RetailerFooterPlaceholder = styled.div.withConfig({
    componentId: "sc-b077c403-1"
})([
    "",
    "{height:750px;}",
    "{height:431px;}"
], responsiveMediaQueries.tabletAndBelow, responsiveMediaQueries.desktopAndAbove);
